import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";

import ViewGerenciarAlugueis from "../views/ViewGerenciarAlugueis";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";
import { ArrowLeft } from "lucide-react";

const ContainerComponente = styled.div`
  display: grid;
  grid-template: 100px 75vh 90rem 170rem 20rem / auto;
  @media (min-width: 1100px) {
    grid-template: 100px 100vh 20rem / auto;
  }
`;
const BackButton = styled.button`
  position: absolute;
  top: 110px; /* distância abaixo do AppBar */
  left: 40px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  padding: 0.6rem;
  cursor: pointer;
  color: #fff;
  transition: background 0.3s ease, transform 0.2s ease;
  z-index: 20;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
  }

  svg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    top: 90px;
    left: 20px;
    padding: 0.5rem;
    svg {
      width: 20px;
      height: 20px;
    }
  }
`; 

const GerenciarAlugueis: React.FC = () => {
   const { isLoading, isValid } = usePermissao("OPE");

    const handleVoltar = () => {
    // 🔙 Volta para a página anterior
    window.history.back();
  };
    
      if (isLoading) return <p>Verificando permissão...</p>;
      if (!isValid) return null;
    return (
  <ContainerComponente>
    <BackButton onClick={handleVoltar} title="Voltar">
            <ArrowLeft />
          </BackButton>
    <ViewAppBar />
    <ViewGerenciarAlugueis />
    <ViewFooter />
  </ContainerComponente>
)};
export default GerenciarAlugueis;
